import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const useScrollAnimations = () => {
  const location = useLocation();
  const observerRef = useRef(null);

  useEffect(() => {
    if (observerRef.current) observerRef.current.disconnect();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-visible');
          }
        });
      },
      { threshold: 0.08, rootMargin: '50px 0px -20px 0px' }
    );

    observerRef.current = observer;

    // Small delay to let React render complete
    const timer = setTimeout(() => {
      const selectors = [
        'section h2', 'section h3',
        'section > div > p', 'section > div > div > p',
        '.scroll-animate',
        'section .grid > div', 'section .grid > a',
        'section ul > li'
      ].join(', ');

      const elements = document.querySelectorAll(selectors);
      elements.forEach((el) => {
        // Skip nav, header, footer-cta, and hero sections
        if (el.closest('nav') || el.closest('header') || el.closest('[data-testid*="hero"]')) return;
        if (el.classList.contains('scroll-init')) return;

        el.classList.add('scroll-init');
        observer.observe(el);
      });
    }, 200);

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, [location.pathname]);
};

export default useScrollAnimations;
